import { ROUTE } from "../../../routes";
import { ButtonTypeTokens } from "@voltmoney/schema";
import { addCommasToNumber } from "../../../configs/utils";
import SharedPropsService from "../../../SharedPropsService";
import { getTotalLimit } from "../portfolio/actions";
import { ConfigValues, getAppHeader } from "../../../configs/config";
import { listItemDataBuilder } from "./utils";
import { getDesiredValue } from "../portfolio_readonly/actions";
import { api } from "../../../configs/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ACTION } from "../../afterUnlock/confirm_amount/types";
let value = ConfigValues.MinimumAmountAllowed.toString();
const getUpdateAvailableCAS = (amountRequired, availableCAS, isinNavMap, isinLTVMap) => {
    const updateAvailableCAS = [];
    for (let i = 0; i < availableCAS.length; i++) {
        const item = availableCAS[i];
        const individualAmount = getTotalLimit([item], isinNavMap, isinLTVMap);
        if (amountRequired >= individualAmount) {
            updateAvailableCAS.push(item);
            amountRequired = amountRequired - individualAmount;
        }
        else {
            const ratio = amountRequired / individualAmount;
            const newItem = {
                ...item,
                pledgedUnits: Math.ceil(item.totalAvailableUnits * ratio * 1000) / 1000,
            };
            updateAvailableCAS.push(newItem);
            amountRequired = 0;
        }
    }
    if (amountRequired > 0) {
        /// throw error
        return [];
    }
    return updateAvailableCAS;
};
const minVal = (camsTotalVal, karvyTotalVal) => {
    if (karvyTotalVal <= camsTotalVal)
        return karvyTotalVal;
    return camsTotalVal;
};
const rtaMinToBeSelected = (camsTotalVal, karvyTotalVal) => {
    if (karvyTotalVal <= camsTotalVal)
        return "KARVY";
    return "CAMS";
};
const maxVal = (camsTotalVal, karvyTotalVal) => {
    if (karvyTotalVal > camsTotalVal)
        return karvyTotalVal;
    return camsTotalVal;
};
const rtaMaxToBeSelected = (camsTotalVal, karvyTotalVal) => {
    if (karvyTotalVal > camsTotalVal)
        return "KARVY";
    return "CAMS";
};
export const OnChangeSlider = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    /** On change of value update updateAvailableCASMap **/
    setDatastore(ROUTE.SET_CREDIT_LIMIT, 'ctaButton', {
        type: ButtonTypeTokens.LargeFilled
    });
};
export const OnChangeCompleteSlider = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    value = action.payload.value;
    /** On change of value update updateAvailableCASMap **/
    const stepResponseObject = action.payload.stepResponseObject;
    let camsTotalVal = stepResponseObject.repositoryAssetMetadataMap.CAMS.availableCreditAmount;
    let karvyTotalVal = stepResponseObject.repositoryAssetMetadataMap.KARVY.availableCreditAmount;
    let selectedRta = "KARVY";
    let nonSelectedRta = "CAMS";
    if (value <= minVal(camsTotalVal, karvyTotalVal)) {
        selectedRta = rtaMinToBeSelected(camsTotalVal, karvyTotalVal);
    }
    else if (value > minVal(camsTotalVal, karvyTotalVal) && value <= maxVal(camsTotalVal, karvyTotalVal)) {
        selectedRta = rtaMaxToBeSelected(camsTotalVal, karvyTotalVal);
    }
    else
        selectedRta = "KARVY";
    if (selectedRta === "CAMS")
        nonSelectedRta = "KARVY";
    const sortedCasList = stepResponseObject.availableCAS.sort((a, b) => {
        const order = [selectedRta, nonSelectedRta];
        return order.indexOf(a.assetRepository) - order.indexOf(b.assetRepository);
    });
    stepResponseObject.availableCAS = sortedCasList;
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    if (parseInt(value) > 0) {
        stepResponseObject.availableCAS.forEach((item, index) => {
            stepResponseObject.availableCAS[index].pledgedUnits =
                stepResponseObject.availableCAS[index].pledgedUnits =
                    item.totalAvailableUnits;
        });
        stepResponseObject.availableCAS = getUpdateAvailableCAS(parseInt(value), stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        stepResponseObject.availableCAS.map((item, index) => {
            const key = `${item.isinNo}-${item.folioNo}`;
            updateAvailableCASMap[key] = item;
        });
    }
    else {
        stepResponseObject.availableCAS.map((item, index) => {
            const key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
    }
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
    /** **/
    const updatedListProps = await listItemDataBuilder(stepResponseObject);
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "listItem", {
        data: updatedListProps,
    });
    await SharedPropsService.setCreditLimit(parseInt(value));
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "slider", {
        value: SharedPropsService.getCreditLimit(),
    });
    const portValue = getDesiredValue(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap);
    await SharedPropsService.setDesiredPortfolio(portValue);
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "bottomStackText", {
        label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
    });
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "bottomSheetText2", {
        label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action.payload.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
    });
};
export const goBack = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    const isFromMFCentral = action?.payload?.isFromMFCentral;
    if (isFromMFCentral) {
        await navigate(ROUTE.MFC_FETCH_ANCHOR);
    }
    else {
        await navigate(ROUTE.MF_PLEDGE_PORTFOLIO);
    }
};
// changed here
export const goConfirmPledge = async (action, _datastore, { navigate, showPopup, setDatastore, network }) => {
    let platform = await SharedPropsService.getAppPlatform();
    const stepResponseObject = action.payload.stepResponseObject;
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    const updatedList = [];
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    Object.keys(updateAvailableCASMap).forEach((key) => {
        const updatedItem = updateAvailableCASMap[key];
        updatedList.push(updatedItem);
    });
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "ctaButton", {
        loading: true
    });
    const toBeSavedPortfolios = updatedList.filter(item => item.pledgedUnits > 0);
    const toBeSavedPortfolios_SetPledgeToTrue = toBeSavedPortfolios.map(item => {
        return {
            ...item,
            is_pledged: true
        };
    });
    const savePortfolio = await network.post(api.savePortfolio, {
        applicationId: applicationId,
        portfolioItemList: toBeSavedPortfolios_SetPledgeToTrue,
    }, { headers: await getAppHeader() });
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
    if (savePortfolio?.status === 200) {
        if (await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow())) {
            await navigate(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, { stepResponseObject });
        }
        else {
            await navigate(ROUTE.PLEDGE_CONFIRMATION, { stepResponseObject });
        }
    }
    else {
        await showPopup({
            title: "We could not save your fund selection because of an internal error",
            type: 'FAILED',
            ctaLabel: 'Retry now',
            ctaAction: {
                routeId: ROUTE.SET_CREDIT_LIMIT,
                type: ACTION.CLOSE_POPUP,
                payload: {}
            },
            primary: true
        });
    }
};
export const goToEditPortFolio = async (action, _datastore, { instrumentTrack, navigate, goBack, setDatastore }) => {
    instrumentTrack("SET_MF_LIMIT_PORTFOLIO_PAGE_VIEWED");
    const stepResponseObject = action.payload.stepResponseObject;
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    //const editAmount = await SharedPropsService.getCreditLimit()
    /*
    if (editAmount > 0) {
      stepResponseObject.availableCAS.forEach((item, index) => {
        stepResponseObject.availableCAS[index].pledgedUnits =
            item.totalAvailableUnits;
      });
      stepResponseObject.availableCAS = getUpdateAvailableCAS(
          editAmount,
          stepResponseObject.availableCAS,
          stepResponseObject.isinNAVMap,
          stepResponseObject.isinLTVMap
      );
      stepResponseObject.availableCAS.map((item, index) => {
        let key = `${item.isinNo}-${item.folioNo}`;
        updateAvailableCASMap[key] = item;
      });
    } else {
      stepResponseObject.availableCAS.map((item, index) => {
        let key = `${item.isinNo}-${item.folioNo}`;
        item.pledgedUnits = item.totalAvailableUnits;
        updateAvailableCASMap[key] = item;
      });
    }
     */
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
    await navigate(ROUTE.PORTFOLIO, {
        stepResponseObject,
        updateAvailableCASMap,
    });
};
export const editSliderAmount = async (action, _datastore, { instrumentTrack, navigate, ...props }) => {
    instrumentTrack("EDIT_AMOUNT_BUTTON_CLICKED");
    const isFromMFCentral = action?.payload?.isFromMFCentral;
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    await navigate(ROUTE.UPDATE_SLIDER_AMOUNT, {
        maxAmount: action.payload.maxAmount,
        stepResponseObject: action.payload.stepResponseObject,
        updateAvailableCASMap: updateAvailableCASMap,
        isFromMFCentral: isFromMFCentral
    });
};
export const needHelp = async (action, _datastore, { navigate, ...props }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const closePopup = async (action, _datastore, { hidePopup }) => {
    await hidePopup();
};
